import React, { useEffect } from "react";
import Footer from "../utils/core/Footer";
import UserHeader from "../utils/user/UserHeader";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { emailActivationAction } from "../../redux/actions/authentication/authenticationAction";

export const EmailActivation = (props) => {
  const navigate = useNavigate();

  const onSubmit = () => {
    props.emailActivation(props.user.email, navigate);
  };
  
  // useEffect(() => {
  //   const css = `
  //     /* Fix flex alignment when the columns stack (tablet) */
  //     @media (max-width: 991.98px) and (min-width: 768px) {
  //       .login-page .login-area .row.align-items-center {
  //         align-items: flex-start !important;
  //       }

  //       /* Give some gap between hex icons and "Hello Rahulout" block */
  //       .login-page .login-area .login-form {
  //         margin-top: 32px;
  //       }

  //       /* Optional: slightly smaller heading in this range */
  //       .login-page .login-area .login-form .inner-content h2 {
  //         font-size: 30px;
  //         line-height: 40px;
  //       }
  //     }

  //     /* Make feature icons behave nicely on all widths */
  //     .login-page .features-list-block .features-list {
  //       display: flex !important;
  //       flex-wrap: wrap;
  //       justify-content: center;
  //       align-items: center;
  //       padding-top: 40px;
  //     }
  //   `;

  //   const style = document.createElement("style");
  //   style.innerHTML = css;
  //   document.head.appendChild(style);

  //   return () => {
  //     document.head.removeChild(style);
  //   };
  // }, []);

//   useEffect(() => {
//   const css = `
//     /* Make feature icons behave nicely on all widths */
//     .login-page .features-list-block .features-list {
//       display: flex !important;
//       flex-wrap: wrap;
//       justify-content: center;
//       align-items: center;
//       padding-top: 40px;
//     }

//     /* Tablets + small desktops (including iPad Pro) */
//     @media (max-width: 1199.98px) and (min-width: 768px) {
//       /* stop vertical centering when space is tight */
//       .login-page .login-area .row.align-items-center {
//         align-items: flex-start !important;
//       }

//       /* give a gap between hex icons and "Hello Rahulout" block */
//       .login-page .login-area .login-form {
//         margin-top: 32px;
//       }

//       /* slightly smaller heading on these widths */
//       .login-page .login-area .login-form .inner-content h2 {
//         font-size: 30px;
//         line-height: 40px;
//       }

//       /* optional: a bit less vertical padding */
//       .login-page .login-area {
//         padding: 40px 0 60px;
//       }
//     }
//   `;

//   const style = document.createElement("style");
//   style.innerHTML = css;
//   document.head.appendChild(style);

//   return () => {
//     document.head.removeChild(style);
//   };
// }, []);







  


  return (
    <div className="login-page">
      {/* <UserHeader></UserHeader> */}
      <main>
        <section className="login-area">
          <div className="container">
            {/* <div className="row align-items-center"> */}
            <div className="row ">

            {/* <div className="col-12 col-lg-6"> */}
            <div className="col-12 col-xl-6 mb-4 mb-xl-0">
                  <div className="inner-content features-list-block">
                    <h2>
                      Welcome to <br />a new era
                    </h2>
                    <p>
                      {/* Intro to the log in / sign up if required. Intro to the
                      log in / sign up if required. Intro to the log in / sign
                      up if required.{" "} */}
                      Log In and continue to enhance your prospects and your energy
     sector journey.
                    </p>
                    <ul className="features-list">
                      <li className="text-center">
                        <div className="img-wrap text-center">
                          <img
                            src="/assets/images/icons/profile.svg"
                            alt="neet"
                          />
                        </div>
                        <div className="feature-name">
                          MY <strong>Profile</strong>
                        </div>
                      </li>
                      <li className="text-center">
                        <div className="img-wrap text-center">
                          <img
                            src="/assets/images/icons/analytics.svg"
                            alt="neet"
                          />
                        </div>
                        <div className="feature-name">
                          MY <strong>Analytics</strong>
                        </div>
                      </li>
                      <li className="text-center">
                        <div className="img-wrap text-center">
                          <img
                            src="/assets/images/icons/network.svg"
                            alt="neet"
                          />
                        </div>
                        <div className="feature-name">
                          MY <strong>Network</strong>
                        </div>
                      </li>
                      <li className="text-center">
                        <div className="img-wrap text-center">
                          <img
                            src="/assets/images/icons/performance.svg"
                            alt="neet"
                          />
                        </div>
                        <div className="feature-name">
                          MY <strong>Performance</strong>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              {/* <div className="col-12 col-lg-6 text-center"> */}
              <div className="col-12 col-xl-6 text-center">
                <div className="login-form">
                  <div className="inner-content">
                    <h2>Hello {props.user.username}</h2>
                    <p>
                      Verify your e-mail to access the Dashboard, My Profile, My
                      Analytics, My Performance, My Network pages. If you don't
                      recieve a email or expired your email. To generate press
                      the button to verify your account
                    </p>
                  </div>
                  <h5>Send Mail Activation link</h5>
                  <button
                    type="submit"
                    onClick={onSubmit}
                    className="btn btn-signup"
                  >
                    Send Mail
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="img-list">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                <figure>
                  <img
                    className="img-fluid w-100"
                    src="/assets/images/img2.png"
                    alt="neet"
                  />
                </figure>
              </div>
              <div className="col">
                <figure>
                  <img
                    className="img-fluid w-100"
                    src="/assets/images/img3.png"
                    alt="neet"
                  />
                </figure>
              </div>
              <div className="col">
                <figure>
                  <img
                    className="img-fluid w-100"
                    src="/assets/images/img4.png"
                    alt="neet"
                  />
                </figure>
              </div>
              <div className="col">
                <figure>
                  <img
                    className="img-fluid w-100"
                    src="/assets/images/img5.png"
                    alt="neet"
                  />
                </figure>
              </div>
              <div className="col">
                <figure>
                  <img
                    className="img-fluid w-100"
                    src="/assets/images/img6.png"
                    alt="neet"
                  />
                </figure>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer></Footer>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  return {
    user: user,
    profile: profile,
  };
};

const mapDispatchToProps = (dispatch, state) => {
  return {
    emailActivation: (email, navigate) =>
      dispatch(emailActivationAction(email, navigate)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailActivation);
